export default "__VITE_ASSET__DSTQxPik__"